import React, { useMemo } from 'react'
import { DatePickerInput } from 'react-native-paper-dates'
import { DateAdapter } from '@/data/protocols'
import { useTheme } from '@/presentation/hooks'
import { styles } from './styles'

type DatePickerProps = {
  dateAdapter: DateAdapter
  label: string
  value: Date | undefined
  onChange: (date: Date | undefined) => void
  disabled?: boolean
  initYear?: number
  finalYear?: number
  testID?: string
  backgroundColor?: string
  textColor?: string
}

export const DatePicker: React.FC<DatePickerProps> = ({
  label,
  value,
  onChange,
  disabled,
  initYear,
  finalYear,
  dateAdapter,
  testID,
  backgroundColor,
  textColor
}) => {
  const theme = useTheme()

  const INITIAL_YEAR = useMemo(() => initYear ?? dateAdapter.today().getFullYear() - 5, [])
  const FINAL_YEAR = useMemo(() => finalYear ?? dateAdapter.today().getFullYear() + 12, [])
  const safeValue = value && !Number.isNaN(value.getTime()) ? value : undefined

  const inputStyle = {
    ...styles.container,
    backgroundColor: backgroundColor ?? theme.colors.backgroundInput,
    color: textColor ?? theme.colors.greyDark
  }

  return (
    <DatePickerInput
      inputMode="start"
      locale="pt-BR"
      value={safeValue}
      label={label}
      disabled={disabled}
      style={inputStyle}
      textColor={textColor}
      startYear={INITIAL_YEAR}
      endYear={FINAL_YEAR}
      withDateFormatInLabel={false}
      inputEnabled={false}
      onChange={onChange}
      testID={testID}
    />
  )
}
